var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none;\n  @media (min-width: 769px) {\n    display: block;\n  }\n'], ['\n  display: none;\n  @media (min-width: 769px) {\n    display: block;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject);

var Desktop = function Desktop(props) {
  return React.createElement(Container, null, props.children);
};

export default Desktop;